export default {
      id: "copy-line-usage",
      viewBox: "0 0 36 36",
      url: "assets/" + "sprite.svg#copy-line-usage",
      toString: function () {
        return this.url;
      }
    }